import { Module, Polyline } from './common'

/**
 * Base postprocessing module - transforms polylines
 */
export abstract class Postprocessing extends Module {
  /**
   * Process polylines and return transformed polylines
   * @param polylines - Input polylines
   * @returns Transformed polylines
   */
  abstract run(polylines: Polyline[]): Polyline[]

  /**
   * Get a human-readable name for this postprocessing step
   */
  abstract getName(): string
}
